<template>
  <loader v-bind="{ loading }">
    <div class="position-relative mr-1 show-on-hover uploaded-image asset-image has-background-primary-light">
      <icon v-if="imageUrl" @click="clearImage" icon="times-circle"
            class="icon-buttons has-text-grey clear-image-icon"/>
      <img v-if="imageUrl" :src="imageUrl" alt="Asset Type" class=""/>
      <div v-else class="is-flex align-items-center justify-center">
        <q-r-code-icon style="margin: 1px 0 0 1px" color="has-text-cool-blue-text" :size="60"/>
      </div>
      <icon @click="openImage" icon="camera" class="icon-buttons hover-camera-icon has-text-grey"/>
    </div>
  </loader>
</template>

<script>
import QRCodeIcon from "@/components/ui/icons/QRCodeIcon.vue";
import {mapGetters} from "vuex";
import {uploadAssetTypeImage} from "@/modals";

export default {
  computed: {
    ...mapGetters('assetType', ['assetType']),
    iconClass() {
      return this.location === 'thumbnail' ? 16 : 60;
    },
  },

  components: {QRCodeIcon},

  props: {
    imageUrl: {
      type: String,
      required: false,
      default: null
    },
  },

  data: () => ({
    loading: false,
  }),

  methods: {
    async clearImage() {
      this.loading = true
      await this.$store.dispatch('assetType/clearImage', this.assetType.id)
          .then(() => {
            this.$toast.success('Image cleared')
          })
          .catch(() => this.$whoops())
      this.loading = false
    },
    openImage() {
      uploadAssetTypeImage()
    },
  }

}
</script>

<style>
.asset-image {
  width: 150px;
  height: 150px;
  border-radius: 5px;
}

.position-relative {
  position: relative;
}

.icon-buttons {
  display: none;
  position: absolute;
  right: 5px;
  cursor: pointer;

  :hover {
    background-color: white;
  }
}

.hover-camera-icon {
  padding: 0.15rem 0.3rem 0.2rem 0.3rem;
  bottom: 5px;
}

.clear-image-icon {
  padding: 0.14rem 0.15rem 0.15rem 0.15rem;
  top: 5px;

  :hover {
    color: red;
  }
}

.show-on-hover:hover .hover-camera-icon,
.show-on-hover:hover .clear-image-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 50%;

  :hover {
    color: grey;
  }
}
</style>